import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { useAuthState } from '@/features/auth/hooks/useAuthState';
import type { LoginCredentials } from '@/types/auth.types';
import type { UserInfo } from '../types/auth.types';

interface AuthContextType {
  isAuthenticated: boolean;
  isInitializing: boolean;
  userInfo: UserInfo | null;
  login: (credentials: LoginCredentials) => Promise<boolean>;
  logout: () => void;
  showPasswordModal: boolean;
  setShowPasswordModal: (show: boolean) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error(
      "useAuthContext doit être utilisé à l'intérieur d'un AuthProvider"
    );
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const auth = useAuthState();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
